import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import cN from 'classnames';
import styles from './styles.module.scss';
import { updateFilterItems } from '@utils/utils';
import { I_FilterItem, I_TripType } from '@Redux/search/interfaces';
import {
    setFilterItems,
    setTempFilterItems,
    setTagFiltersShow,
    setTempTagFiltersShow,
    setChangeItem,
} from '@Redux/search/actions';
import { RootState } from '@Redux/search/store';
import * as Tag from '@components/Common/Tag';
import Skeleton from '@components/Common/Skeletons';
import { useMediaQuery } from 'react-responsive';

interface ConditionsProps {
    whenClick?: (items: I_FilterItem[]) => void;
}

const urlParams = new URLSearchParams(window.location.search);
const TravelType = urlParams.get('TravelType');

const Conditions: React.FC<ConditionsProps> = ({ whenClick }) => {
    const moduleName = 'conditions';
    const dispatch = useDispatch();
    const {
        TagFiltersShow,
        FilterItems,
        GroupListInfo,
        GroupListInfoM,
        SingleGroupListInfo,
        SingleGroupListInfoM,
        SwitchListBy,
        DepthInfo,
    } = useSelector((state: RootState) => state.search);
    const isPC = useMediaQuery({ query: '(min-width: 980px)' });
    const hasFilterItems = FilterItems.length !== 0;
    const { isLoading: isGroupDataLoading } = GroupListInfo;
    const { isLoading: isGroupDataLoadingM } = GroupListInfoM;

    useEffect(() => {
        // 團體自由行引擎時，移除旅遊型態的篩選 tag
        if (TravelType === '2') {
            const filterFilterByItems = FilterItems.filter(
                (filterItem: I_FilterItem) => filterItem.filterBy !== 'TravelType'
            );
            dispatch(setFilterItems(filterFilterByItems));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const isCards = SwitchListBy === 'List';

    const totalCount = (() => {
        if (isCards) {
            return isPC ? GroupListInfo.data?.TotalCount : GroupListInfoM.data?.TotalCount;
        } else {
            return isPC
                ? SingleGroupListInfo.data?.TotalCount
                : SingleGroupListInfoM.data?.TotalCount;
        }
    })();

    let curTripTypeList;

    if (DepthInfo?.TripTypeList) {
        curTripTypeList = DepthInfo.TripTypeList?.filter(({ TypeCode }: { TypeCode: string }) => {
            return TagFiltersShow.indexOf(TypeCode) !== -1;
        });
    }

    return (
        <div className={cN(moduleName, styles[`${moduleName}`])}>
            {!isGroupDataLoading || !isGroupDataLoadingM ? (
                <div className={styles.ItemQty}>
                    <span className={styles.Count}>{totalCount | 0}</span>
                    <span>項精彩行程</span>
                </div>
            ) : (
                <div className={isPC ? '' : 'v-hide'}>
                    <Skeleton part="oneRow" />
                </div>
            )}

            {/* 遊玩交通標籤 */}
            {DepthInfo?.TripTypeList &&
                curTripTypeList.map((item: I_TripType) => {
                    return (
                        <div
                            key={item.TypeCode}
                            className={styles.Tagwrap}
                            onClick={() => {
                                const newTagFiltersShow = TagFiltersShow.filter(
                                    (TypeCode: string) => TypeCode !== item.TypeCode
                                );
                                const newFilterItems = FilterItems.filter(
                                    ({ subValue }: I_FilterItem) => subValue !== item.TypeCode
                                );
                                dispatch(setTagFiltersShow(newTagFiltersShow));
                                dispatch(setTempTagFiltersShow(newTagFiltersShow));
                                dispatch(setFilterItems(newFilterItems));
                                dispatch(setTempFilterItems(newFilterItems));
                                dispatch(setChangeItem(true));
                            }}
                        >
                            <Tag.Selectable
                                text={item.TypeName}
                                tripType={item.TypeCode}
                                isClosable
                            />
                        </div>
                    );
                })}
            {/* 一般標籤 */}
            {DepthInfo?.CategoryList &&
                FilterItems.map((item: I_FilterItem) => {
                    return (
                        <div
                            key={`${item.filterBy}${item.value}${item.text}`}
                            className={styles.Tagwrap}
                            onClick={() => {
                                const props = {
                                    data: FilterItems,
                                    nowType: item.filterBy,
                                    value: item.value,
                                    text: item.text,
                                    subValue: '',
                                };
                                const newFilterItems = updateFilterItems(props);
                                dispatch(setFilterItems(newFilterItems));
                                dispatch(setTempFilterItems(newFilterItems));
                                whenClick && whenClick(newFilterItems);
                                dispatch(setChangeItem(true));
                            }}
                        >
                            <Tag.Selectable text={item.text} isClosable />
                        </div>
                    );
                })}
            {DepthInfo?.CategoryList && hasFilterItems && (
                <div
                    className={styles.Reset}
                    onClick={() => {
                        dispatch(setFilterItems([]));
                        dispatch(setTempFilterItems([]));
                        dispatch(setTagFiltersShow([]));
                        dispatch(setTempTagFiltersShow([]));
                        whenClick && whenClick([]);
                        dispatch(setChangeItem(true));
                    }}
                >
                    <Tag.Selectable text="重設條件" />
                </div>
            )}
        </div>
    );
};

export default Conditions;
